import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getUserMaterialItems = async () => {
  try {
    const res = await axiosInstance.get(API_ROUTES.MaterialItems)
    return res.data
  } catch (error) {
    console.error('Error fetching material items:', error)
    throw error
  }
}

export default getUserMaterialItems
